import React from 'react';
import ReactApexChart from 'react-apexcharts';

const EnachChart = ({ grandTotals, authModeData }) => {
  // Extract grand total values
  const totalSuccess = grandTotals["grandTotalSuccess"];
  const totalFailed = grandTotals["grandTotalFailed"];
  const totalAborted = grandTotals["grandTotalAborted"];
  const totalPending = grandTotals["grandTotalPending"];
  const totalRegistered = grandTotals['grandTotalHits'];

  // Data for the chart
  const categories = ['Total Success', 'Total Failed', 'Total Pending', 'Total Registered', 'Total Aborted'];
  const series = [
    {
      name: 'Count',
      data: [totalSuccess, totalFailed, totalPending, totalRegistered, totalAborted]
    }
  ];

  // Extract counts by auth_mode
  const successByAuthMode = authModeData.reduce((acc, item) => {
    // acc[item.auth_mode || 'Unknown'] = item.TotalSuccess;
    if(item.auth_mode) {
      
      acc[item.auth_mode] = item.TotalSuccess;
    }
    return acc;
  }, {});

  const failureByAuthMode = authModeData.reduce((acc, item) => {
    // acc[item.auth_mode || 'Unknown'] = item.TotalFailed;
    if(item.auth_mode) {

      acc[item.auth_mode] = item.TotalFailed;
    }
    return acc;
  }, {});

  const pendingByAuthMode = authModeData.reduce((acc, item) => {
    // acc[item.auth_mode || 'Unknown'] = item.TotalPending;
    if(item.auth_mode) {

      acc[item.auth_mode] = item.TotalPending;
    }
    return acc;
  }, {});

  const abortedByAuthMode = authModeData.reduce((acc, item) => {
    // acc[item.auth_mode || 'Unknown'] = item.TotalAborted;
    if(item.auth_mode) {

      acc[item.auth_mode] = item.TotalAborted;
    }
    return acc;
  }, {});

  const totalRegisteredByAuthMode = authModeData.reduce((acc, item) => {
    // Calculate totalRegistered as the sum of success, failed, pending, and aborted
    const totalRegistered = (item.TotalSuccess || 0) + (item.TotalFailed || 0) + (item.TotalPending || 0) + (item.TotalAborted || 0);
    
    // acc[item.auth_mode || 'Unknown'] = totalRegistered;
    if(item.auth_mode) {
      acc[item.auth_mode] = totalRegistered;
    }
    return acc;
  }, {});

  // Calculate the total counts
  const totalCounts = [
    { name: 'Total Success', total: totalSuccess },
    { name: 'Total Failed', total: totalFailed },
    { name: 'Total Aborted', total: totalAborted },
    { name: 'Total Pending', total: totalPending },
    { name: 'Total Registered', total: totalRegistered },
  ];

  // Chart options
  const options = {
    chart: {
      type: 'bar',
      height: 500,
      stacked: false,
      toolbar: {
        show: false // Hides the default toolbar
      },
    },
    plotOptions: {
      bar: {
        horizontal: false, // Ensure bars are vertical
        columnWidth: '50%', // Adjust the width of the bars
        dataLabels: {
          position: 'top' // Position data labels on top of bars
        },
      },
    },
    dataLabels: {
      enabled: true, // Enable data labels
      formatter: function (val) {
        return val; // Show the actual value as a label
      },
      offsetY: -20, // Adjust the Y offset so the label is above the bar
      style: {
        fontSize: '14px',
        colors: ['#304758'] // Custom label color
      }
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    title: {
      text: 'Grand Total Summary'
    },
    xaxis: {
      categories: categories, // Categories for the X-axis
      labels: {
        formatter: function (val) {
          return val;
        }
      }
    },
    yaxis: {
      title: {
        text: 'Total Count' // Label for y-axis
      },
    },
    tooltip: {
      x: {
        formatter: function (val, { seriesIndex, dataPointIndex, w }) {
          const tooltips = {
            0: successByAuthMode,
            1: failureByAuthMode,
            2: pendingByAuthMode,
            3: totalRegisteredByAuthMode,
            4: abortedByAuthMode,
          };

          if (tooltips[dataPointIndex]) {
            const breakdown = Object.entries(tooltips[dataPointIndex])
              .map(([authMode, count]) => {

                  return `<p><span style="font-weight=400">${authMode}</span>: <span style="font-weight=700">${count}</span></p>`
                
                })
              .join('');
                
              return `<div style="padding: 5px;">${breakdown}</div>`;
          } else {
            return val; // Tooltip to show actual values for other bars
          }
        }
      },
      shared: true, // Show tooltip for all series data points
      intersect: false // Allow tooltip to show on hover over the bar
    },
    fill: {
      opacity: 1
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 40
    },
    colors: ['#5470c6'] // Custom color for the series
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div style={{ flex: 1 }}>
        <ReactApexChart options={options} series={series} type="bar" height={500} width={"100%"}/>
      </div>
      <div
        style={{
          padding: "10px",
          backgroundColor: "inherit",
          borderTop: "1px solid #ddd",
        }}
        className='px-4 py-2'
      >
        <div className="d-flex flex-column">
          <div>
            <div style={{ color: "#36454F", fontSize: "16px", fontWeight: "600" }} className='mb-2'>
              Total Counts:
            </div>
            <div className='d-flex gap-2 flex-wrap'>
              {totalCounts.map((item, index) => (
                <div
                key={index}
                style={{
                  marginBottom: "5px",
                  fontSize: "14px"
                }}
                className="d-flex align-items-center justify-content-end mr-2" 
                >
                  <div
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: options.colors[0], // Use the same color as the bars
                      display: "inline-block",
                      marginRight: "5px",
                      borderRadius: "50%",
                    }}
                    ></div>
                  <span
                    className="d-block me-1"
                    style={{ fontWeight: "500", color: "#808080" }}
                    >
                    {item.name}:
                  </span>
                  <span style={{ color: "#000000", fontWeight: "700" }}>
                    {item.total}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnachChart;


